import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {licenceSuspensionQuestionSelect} from '../../redux/selector/licenceDetailsSelector'
import {setLicenceSuspensionQuestionAnswer} from '../../redux/slice/licenceSuspensionSlice'
import {
    Header, 
    Paragraph, 
    Button
} from '../../components/RegularComponents'
import TopNavigationBar from "../TopNavigationBar"
import {replaceCollectorName, replaceUrlParams} from '../../app/utils'
import Navigation from '../Navigation';
import { 
    APPLICATION_TYPE_COLLECTOR, 
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT,
    ROUTE_PATH
} from '../../app/constants';
import { setCurrentAgentLicenceSuspsnsionDetails } from '../../redux/slice/additionalApplicationsSlice';
import { setAgencyLicenceSuspensionDetails } from '../../redux/slice/primaryAgencyApplicationSlice';

const LicenceSuspensionQuestion = (props) => {
    const {dispatch} = props
    const {applicationType, applicationMode} = props.match.params
    const {collectorApplication} = props.licenceSuspensionQuestion
    
    const licenceSuspensionQuestion = props.licenceSuspensionQuestion[applicationType] ? 
        props.licenceSuspensionQuestion[applicationType] : props.licenceSuspensionQuestion

    let paragraphText = licenceSuspensionQuestion.text
    if(applicationType === APPLICATION_TYPE_COLLECTOR || 
        applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {

        let collectorName = applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT ? "Debt Management Agent" : "Collector"

        if(collectorApplication) {

            if (collectorApplication.applicantDetails 
                && collectorApplication.applicantDetails.firstName) {
                collectorName = collectorApplication.applicantDetails.firstName
            }
        } 

        paragraphText = paragraphText.map((text) => replaceCollectorName(text,collectorName))
    }

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
            <TopNavigationBar {...props} />
            <div className="row">
                <div className="col-lg-8">
                    <Header header={licenceSuspensionQuestion.header} />
                    <Paragraph text={paragraphText} />
                    <div className="row">
                        <div className="col-auto">
                            <Button 
                                id="licence-suspension-question-yes"
                                className="ns-btn-yes-no btn-default"
                                text={"Yes"}
                                buttonType={"regular_primary"}
                                onClick={() => {
                                    dispatch(setLicenceSuspensionQuestionAnswer("yes"))
                                    dispatch(push(replaceUrlParams(licenceSuspensionQuestion.navigation.yes, applicationType, applicationMode)))
                                }}
                            />
                        </div>
                        <div className="col-auto">
                            <Button 
                                id="licence-suspension-question-no"
                                className="ns-btn-yes-no btn-default"
                                text={"No"}
                                buttonType={"regular_primary"}
                                onClick={() => {
                                    dispatch(setLicenceSuspensionQuestionAnswer("no"))
                                    let nextUrl = licenceSuspensionQuestion.navigation.no
                                    if(applicationType === APPLICATION_TYPE_COLLECTOR ||
                                        applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
                                        dispatch(setCurrentAgentLicenceSuspsnsionDetails([]))
                                    } else { 

                                        dispatch(setAgencyLicenceSuspensionDetails([]))

                                        if(props.licenceSuspensionQuestion.additionalBranches
                                            && Array.isArray(props.licenceSuspensionQuestion.additionalBranches)
                                            && props.licenceSuspensionQuestion.additionalBranches.length > 0) { 
                                                nextUrl = ROUTE_PATH.ADDITIONAL_BRANCH_DETAILS
                                        }
                                    }

                                    dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)))
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default connect(licenceSuspensionQuestionSelect)(LicenceSuspensionQuestion)
